import {Component, input, computed} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'file-type-icons',
  imports: [
    NgClass
  ],
  templateUrl: './file-type-icons.component.html',
  styleUrl: './file-type-icons.component.scss'
})
export class FileTypeIconsComponent {
  type = input<string | null | undefined>();
  textColour = input<string>('text-surface-400');
  iconType = computed<string>(() => {
    switch (this.type()) {
      case 'image/png':
        return 'fa-regular fa-file-png fa-xl';
      case 'image/jpeg':
      case 'image/jpg':
        return 'fa-regular fa-file-jpg fa-xl';
      case 'pdf':
        return 'fa-regular fa-file-pdf fa-xl';
      case 'xls':
      case 'xlsx':
        return 'fa-regular fa-file-xls fa-xl';
      case 'doc':
      case 'docx':
        return 'fa-regular fa-file-doc fa-xl';
      default:
        return 'fa-regular fa-file fa-xl';
    }
  });
}
